import type { TOC } from '@ember/component/template-only'
import { t } from 'ember-intl'
import { LinkTo } from '@ember/routing'
import { ErrorsImageNoStudents } from 'teacher-ui-client/components/errors/image-no-students'

interface Signature {
  Element: HTMLDivElement
}

export const ErrorsNoStudentsPage: TOC<Signature> = <template>
  <div
    data-test-errors-no-students-page
    class="text-dusty-black-300 mx-auto my-8 max-w-xl space-y-2 text-center"
    ...attributes
  >
    <ErrorsImageNoStudents />
    <h2 data-test-no-students-title>
      {{t "components.errors.noStudents.title"}}
    </h2>
    <p class="text-xl" data-test-no-students-body>
      {{t "components.errors.noStudents.body"}}
      <div>
        {{t "components.errors.noStudents.linkPrefix"}}
        <LinkTo @route="manage.students">{{t "components.errors.noStudents.linkStudentsText"}}</LinkTo>
        {{t "components.errors.noStudents.linkBetween"}}
        <LinkTo @route="manage.classes">{{t "components.errors.noStudents.linkClassesText"}}</LinkTo>
      </div>
      {{t "components.errors.noStudents.end"}}
    </p>
  </div>
</template>

export default ErrorsNoStudentsPage
